import React from 'react'
import Head from 'next/head'

import CategoryList from 'app/InspirationPage/components/revamp/CategoryList'
import { useSETrackEvent } from 'app/InspirationPage/hooks/useSETrackEvent'

export const InspirationCategoryPage = () => {
  const { SETrackCategoryListOpenIdePraktik } = useSETrackEvent()

  const handleTrackPageLoad = (categorySlugs: Array<string>) => {
    SETrackCategoryListOpenIdePraktik({
      categories: categorySlugs.join(', '),
    })
  }

  return (
    <>
      <Head>
        <title>Ide Praktik - Merdeka Mengajar</title>
        <meta name="description" content="Jelajahi konten praktik terbaik" />
      </Head>

      <CategoryList onSuccessFetching={handleTrackPageLoad} />
    </>
  )
}
export default InspirationCategoryPage
